import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FilterItem} from '../../_models/FilterItem';
import {Subscription} from 'rxjs';
import {skip} from 'rxjs/operators';
import {Ordine} from '../../_models/Ordine';
import {LocalService} from '../../_services/local.service';
import {OrdiniShowColumns} from '../../_models/OrdiniShowColumns';

@Component({
  selector: 'app-ordine-local-header',
  templateUrl: './ordine-local-header.component.html',
  styleUrls: ['./ordine-local-header.component.scss'],
  standalone: false
})
export class OrdineLocalHeaderComponent implements OnInit, OnDestroy {
  @Input() flagTerminate: boolean;
  @Input() totalCount = 0;
  @Input() sortKey = 'dataRegistrazione';
  @Input() sortDirection = false;
  // Posseduto dal padre (OrdiniLocaliComponent), non più dall'header: così l'header e la lista
  // di questa stessa tab condividono sempre lo stesso array, senza passare da un singleton
  // condiviso anche con le altre tab.
  @Input() localFilters: FilterItem[] = [];
  @Output() sortKeyChange = new EventEmitter<string>();
  @Output() sortDirectionChange = new EventEmitter<boolean>();
  @Output() handleRefresh = new EventEmitter<void>();
  subscription: Subscription;
  newOrdinis: Ordine[] = [];
  showColumns: OrdiniShowColumns;

  constructor(private localService: LocalService) { }

  async ngOnInit() {
    this.subscription = this.localService.lastOrdineCreated.pipe(skip(1)).subscribe((_newOrdine: Ordine) => {
      if (_newOrdine != null && !this.flagTerminate && !this.hasNewOrdine(_newOrdine)) {
        this.newOrdinis.unshift(_newOrdine);
      }
    });
    this.showColumns = this.localService.showColumns.value;
    this.subscription.add(this.localService.showColumns.subscribe((_showColumns: OrdiniShowColumns) => this.showColumns = _showColumns));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  sort(key: string) {
    if (this.sortKey === key) {
      this.sortDirectionChange.emit(!this.sortDirection);
    }
    this.sortKey = key;
    this.sortKeyChange.emit(this.sortKey);
    this.handleRefresh.emit();
  }

  refresh = () => {
    this.newOrdinis = [];
    this.handleRefresh.emit();
  };

  private hasNewOrdine(ordine: Ordine): boolean {
    return this.newOrdinis.some((_ordine) =>
      _ordine.organizzazioneId === ordine.organizzazioneId &&
      _ordine.idDocumento === ordine.idDocumento &&
      _ordine.idRiga === ordine.idRiga &&
      _ordine.idRigaLavorazione === ordine.idRigaLavorazione);
  }
}
